export default __webpack_public_path__ + "static/char-16-anr-3e70de14e85f3e25a662ae850d6389cb.webp";